module.exports = {
          srcSet: __webpack_public_path__ + "4c2ed041.jpg"+" 700w"+","+__webpack_public_path__ + "51b4bc0c.jpg"+" 1400w"+","+__webpack_public_path__ + "6f92df59.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "4c2ed041.jpg",width: 700,height: 478},{path: __webpack_public_path__ + "51b4bc0c.jpg",width: 1400,height: 956},{path: __webpack_public_path__ + "6f92df59.jpg",width: 2048,height: 1398}],
          src: __webpack_public_path__ + "4c2ed041.jpg",
          toString:function(){return __webpack_public_path__ + "4c2ed041.jpg"},
          
          width: 700,
          height: 478
        }